<div class="page-layout padding-large m-margin-none m-padding m-padding-top-largest">
	<div class="flex margin-bottom">
		<div class="flex-1 flex center">
			<h4>Search Orders</h4>
		</div>
	</div>

	<div class="flex wrap gap">
		<div class="filter-chip" [ngClass]="!orderFilters.ids || !orderFilters.ids.length ? '' : 'selected'">
			@if (orderFilters.ids && orderFilters.ids.length) {
				<div class="flex center hover" (click)="openDialogIdsFilter()">
					<b class="margin-right-smallest">Order ID:</b>
					@for (id of orderFilters.ids; track id; let last = $last) {
						{{ id }}
						@if (!last) {
							,
						}
					}
				</div>

				<mat-icon class="hover" (click)="cleanFilter('ids')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openDialogIdsFilter()">
					Order ID
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!orderFilters.photographers || !orderFilters.photographers.length ? '' : 'selected'">
			@if (orderFilters.photographers && orderFilters.photographers.length) {
				<div class="flex center hover" (click)="openPhotographerFilterModal()">
					<b class="margin-right-smallest">Photographer:</b>

					@for (photographer of orderFilters.photographers; track photographer; let last = $last) {
						{{ photographer.fullName }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('photographers')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openPhotographerFilterModal()">
					Photographer
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!orderFilters.dueDate ? '' : 'selected'">
			@if (orderFilters.dueDate) {
				<div class="flex center hover" (click)="openDueDateFilterModal()">
					<b class="margin-right-smallest">Due Date:</b>

					{{ orderFilters.dueDate.from | date: 'dd-MM-yyyy' }} - {{ orderFilters.dueDate.to | date: 'dd-MM-yyyy' }}
				</div>
				<mat-icon (click)="cleanFilter('dueDate')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openDueDateFilterModal()">
					Due Date
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!orderFilters.creationDate ? '' : 'selected'">
			@if (orderFilters.creationDate) {
				<div class="flex center hover" (click)="openCreationDateFilterModal()">
					<b class="margin-right-smallest">Creation Date:</b>

					{{ orderFilters.creationDate.from | date: 'dd-MM-yyyy' }} - {{ orderFilters.creationDate.to | date: 'dd-MM-yyyy' }}
				</div>
				<mat-icon (click)="cleanFilter('creationDate')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openCreationDateFilterModal()">
					Creation Date
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!orderFilters.completionDate ? '' : 'selected'">
			@if (orderFilters.completionDate) {
				<div class="flex center hover" (click)="openCompletionDateFilterModal()">
					<b class="margin-right-smallest">Completion Date:</b>

					{{ orderFilters.completionDate.from | date: 'dd-MM-yyyy' }} - {{ orderFilters.completionDate.to | date: 'dd-MM-yyyy' }}
				</div>
				<mat-icon (click)="cleanFilter('completionDate')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openCompletionDateFilterModal()">
					Completion Date
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!orderFilters.statuses || !orderFilters.statuses.length ? '' : 'selected'">
			@if (orderFilters.statuses && orderFilters.statuses.length) {
				<div class="flex center hover" (click)="openStatusFilterModal()">
					<b class="margin-right-smallest">Status:</b>

					@for (status of orderFilters.statuses; track status; let last = $last) {
						{{ status.name }}
						@if (!last) {
							,
						}
					}
				</div>

				<mat-icon (click)="cleanFilter('statuses')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openStatusFilterModal()">
					Status
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>
	</div>

	<div class="margin-top-small">
		<div class="flex column end margin-bottom-small">
			<button [routerLink]="['/company/order-view/new/order-detail-info']" class="flex center">
				<mat-icon>add</mat-icon>
				Create custom order
			</button>
		</div>

		@if (orders && orders.items && orders.items.length) {
			<bt-paginator [pageNumber]="orders.currentPage" [pageSize]="orders.size" [totalNumber]="orders.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>

			<table class="desktop-only">
				<tr>
					<th>Order</th>
					<th>Photographer</th>
					<th>Creation Date</th>
					<th>Due Date</th>
					<th>Completion Date</th>
					<th>Warehouse</th>
					<th>Status</th>
					<th>Action</th>
				</tr>
				@for (item of orders.items; track item) {
					<tr>
						<td>
							{{ item.id }}
						</td>
						<td>{{ item.photographer.fullName }}</td>
						<td>
							{{ item.creationDate | date: 'dd-MM-yyyy' }}
						</td>
						<td>
							{{ item.dueDate | date: 'dd-MM-yyyy' }}
						</td>
						<td>
							{{ item.completionDate | date: 'dd-MM-yyyy' }}
						</td>
						<td>
							{{ item.warehouse?.description }}
						</td>
						<td>
							@if (item.status.id == orderStatus.Draft) {
								<span class="radius bg-light-grey primary-dark padding-right-smallest padding-left-smallest">Draft</span>
							} @else if (item.status.id == orderStatus.Submitted) {
								<span class="radius bg-primary white padding-right-smallest padding-left-smallest">Submitted</span>
								<span class="margin-left-smallest small nowrap">Waiting for label creation</span>
							} @else if (item.status.id == orderStatus.ReadyForPickup) {
								<span class="radius bg-primary white padding-right-smallest padding-left-smallest">Ready for pickup</span>
								<span class="margin-left-smallest small nowrap">Waiting for photographer shots</span>
							} @else if (item.status.id == orderStatus.ShootCompleted) {
								<span class="radius bg-orange padding-right-smallest padding-left-smallest">Shoot completed</span>
								<span class="margin-left-smallest small nowrap">Waiting for BasicNet approvation</span>
							} @else if (item.status.id == orderStatus.InProgress) {
								<span class="radius bg-orange padding-right-smallest padding-left-smallest">In Progress</span>
							} @else if (item.status.id == orderStatus.Rejected) {
								<span class="radius bg-red white padding-right-smallest padding-left-smallest">Rejected</span>
								<span class="margin-left-smallest small nowrap">Waiting for photographer to fix</span>
							} @else if (item.status.id == orderStatus.Approved) {
								<span class="radius bg-green white padding-right-smallest padding-left-smallest">Approved</span>
							}
						</td>
						<td>
							<div class="flex center full-width">
								<a [routerLink]="['/company/order-view/' + item.id + '/order-detail-' + (item.status.id == orderStatus.Draft ? 'info' : 'shots')]" class="hover flex center primary">
									<mat-icon class="small margin-right-smallest">visibility</mat-icon>
									Open
								</a>
								@if (item.status.id == orderStatus.Draft) {
									<span class="margin-left-small hover flex center red" (click)="removeOrder(item)">
										<mat-icon class="small">close</mat-icon>
										Remove
									</span>
								}
							</div>
						</td>
					</tr>
				}
			</table>

			<div class="mobile-only flex column gap">
				@for (item of orders.items; track item) {
					<div class="border radius padding margin-bottom-small">
						<div class="flex center gap margin-bottom-small">
							<span class="status-chip">
								{{ item.status.name }}
							</span>
							<span class="grey">{{ item.creationDate | date: 'dd-MM-yyyy' }}</span>
						</div>
						<div class="flex column gap margin-bottom-small">
							<div>
								<b>Order:</b>
								{{ item.id }}
							</div>
							<div>
								<b>Photographer:</b>
								{{ item.photographer.fullName }}
							</div>
							@if (item.dueDate) {
								<div>
									<b>Due Date:</b>
									{{ item.dueDate | date: 'dd-MM-yyyy' }}
								</div>
							}
							@if (item.completionDate) {
								<div>
									<b>Completion Date:</b>
									{{ item.completionDate | date: 'dd-MM-yyyy' }}
								</div>
							}
						</div>
						<div class="flex column end gap">
							<div class="flex center">
								<a class="hover flex center primary" [routerLink]="['/company/order-view/' + item.id + '/order-detail-info']">
									<mat-icon class="small margin-right-smallest">visibility</mat-icon>
									Open
								</a>
								@if (item.status.id == orderStatus.Draft) {
									<span class="margin-left-small hover flex center red disabled">
										<mat-icon class="small">close</mat-icon>
										Remove
									</span>
								}
							</div>
						</div>
					</div>
				}
			</div>

			<bt-paginator [pageNumber]="orders.currentPage" [pageSize]="orders.size" [totalNumber]="orders.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>
		}

		@if (orders.items.length == 0 && !loading) {
			<div class="flex center bg-light-grey padding-largest justify-center">
				<div class="flex column center gap">
					<i class="fa fa-search fa-2xl margin-bottom grey"></i>
					<span>No data found</span>
				</div>
			</div>
		}
	</div>
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
